export default __webpack_public_path__ + "static/media/filehidden1.d6de43f4.png";